var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBaseline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-baseline",
    transform: "translate(21824 -15756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 24,
    height: 24,
    transform: "translate(-21824 15756)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6029",
    "data-name": "Path 6029",
    d: "M15,3V7.59L7.59,15H3v6H9V16.42L16.42,9H21V3M17,5h2V7H17M5,17H7v2H5",
    transform: "translate(-21824.25 15756)",
    fill: "#2a3072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaseline);
export default __webpack_public_path__ + "static/media/icon-baseline.3da3912bb050ef2b3665db6a61ea0510.svg";
export { ForwardRef as ReactComponent };